import * as types from './mutations-type'

export default { }
